module.exports = __webpack_public_path__ + "img/softIndicatorBase.f20b0d85.png";